import React from "react"
import styled from "styled-components"
import { Container, Row, Col } from "react-grid-system"
import { Heading } from "./typography"
import customBorder from "../images/custom-border.svg"
import RichContentTextBlock from "./richContentTextBlock"

const TableBlock = ({ title, table, fullwidth }) => (
  <>
    {fullwidth ? (
      <Wrapper>
        <Container>
          <Table title={title} table={table} />
        </Container>
      </Wrapper>
    ) : (
      <Table title={title} table={table} />
    )}
  </>
)

const Table = ({ title, table, fullwidth }) => (
  <CustomRow>
    <Col>
      <Box>
        <Heading>{title}</Heading>
        <RichContentTextBlock html={table} />
      </Box>
    </Col>
  </CustomRow>
)

const Wrapper = styled.div``

const CustomRow = styled(Row)`
  /* padding-top: 3rem; */
  padding-bottom: 3rem;
`

const Box = styled.div`
  padding-top: 2rem;
  background-image: url(${customBorder});
  background-repeat: no-repeat;
  & > * {
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

export default TableBlock
